const enabledShopIdentifiers = new Set([
    'trail-ops-staging',
    'trail-ops-staging.myshopify.com',
    'partfits-client-demo',
    'partfits-client-demo.myshopify.com',
]);

// Accepts Shopify Admin URLs, myshopify domains, and bare handles as the same shop identity.
export const normalizeShopIdentifier = (value?: string | null) => {
    if (!value) return '';

    const trimmed = value.trim().toLowerCase();
    try {
        const url = new URL(trimmed);
        if (url.hostname === 'admin.shopify.com') {
            const segments = url.pathname.split('/').filter(Boolean);
            const storeIndex = segments.findIndex((segment) => segment === 'store');
            if (storeIndex >= 0 && segments[storeIndex + 1]) {
                return segments[storeIndex + 1];
            }
        }

        return url.hostname;
    } catch {
        return trimmed
            .replace(/^https?:\/\//, '')
            .replace(/\s+/g, '-')
            .replace(/\/$/, '')
            .trim();
    }
};

const decodeShopifyHost = (host?: string | null) => {
    if (!host) return '';

    try {
        const padded = host.replace(/-/g, '+').replace(/_/g, '/').padEnd(Math.ceil(host.length / 4) * 4, '=');
        return atob(padded);
    } catch {
        return '';
    }
};

// Mirrors the server-side rollout gate so hidden routes stay hidden in the app shell.
export const isProductGuideEnabledForShop = (shopDomain?: string | null) =>
    enabledShopIdentifiers.has(normalizeShopIdentifier(shopDomain));

// The embedded Admin URL is the most visible source of truth while developing inside Shopify Admin.
// This catches /store/trail-ops-staging even if the loaded user profile uses a different domain field.
export const isProductGuideEnabledForCurrentContext = (shopDomain?: string | null) => {
    if (isProductGuideEnabledForShop(shopDomain)) {
        return true;
    }

    if (typeof window === 'undefined') {
        return false;
    }

    const searchParams = new URLSearchParams(window.location.search);
    const shopParam = searchParams.get('shop');
    const hostParam = decodeShopifyHost(searchParams.get('host'));

    return isProductGuideEnabledForShop(shopParam)
        || isProductGuideEnabledForShop(hostParam)
        || isProductGuideEnabledForShop(window.location.href);
};
